import { Input, InputGroup, InputLeftElement, InputRightElement, } from '@chakra-ui/react';
import React, { useState } from 'react';
import { IconMedium600 } from '@RHEnvironmental/pattern-library-tokens/dist/riams';
import SearchIcon from '../../icons/SearchIcon/SeachIcon';
import { useTokens } from '../../../context/TokenProvider';
import CloseIcon from '../../icons/CloseIcon/CloseIcon';
const SEARCH_AFTER_LENGTH = 3;
const SearchBar = ({ placeholder, onChange, disabled = false, searchAfterLength = SEARCH_AFTER_LENGTH, }) => {
    const tokens = useTokens();
    const [value, setValue] = useState('');
    const [isActive, setIsActive] = useState(false);
    const handleChange = (event) => {
        const { value: newValue } = event.target;
        setValue(newValue);
        if (newValue && newValue.length < searchAfterLength)
            return;
        onChange(event.target.value);
    };
    const handleClear = () => {
        setValue('');
        onChange('');
    };
    const handleFocus = () => {
        setIsActive(false);
    };
    const handleBlur = () => {
        if (value.length < searchAfterLength)
            return;
        setIsActive(true);
    };
    const iconOpacity = disabled ? tokens.Opacity04 : undefined;
    const searchStyleOverride = isActive
        ? {
            borderColor: tokens.BorderDark800,
            color: tokens.TextDark800,
        }
        : undefined;
    return (React.createElement(InputGroup, { "data-testid": "search_bar", w: 400, size: "lg" },
        React.createElement(Input, { value: value, size: "lg", disabled: disabled, variant: "search", placeholder: placeholder, style: searchStyleOverride, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, "data-testid": "search-input" }),
        React.createElement(InputLeftElement, { "data-testid": "search-icon", opacity: iconOpacity, verticalAlign: "middle", zIndex: 1 },
            React.createElement(SearchIcon, { fill: tokens.IconLight500 })),
        React.createElement(InputRightElement, { opacity: iconOpacity, hidden: !value, verticalAlign: "middle", onClick: handleClear, "data-testid": "clear-button" },
            React.createElement(CloseIcon, { fill: IconMedium600 }))));
};
export default SearchBar;
